//src/app/services/payments/cart/index.tsx
import api from '../..';
import {
  Cart,
  IaddCartItemService,
  IaddCartItemProject,
} from 'app/services/responseTypes';

export const CartApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCartItems: builder.query<Cart, 'Project' | 'Service'>({
      query: (type: 'Project' | 'Service') => `carts?filters[type]=${type}`,
      providesTags: () => [{ type: 'Cart', id: 'LIST' }],
      transformResponse: (response: { cart: Cart }) => response.cart,
    }),
    deleteCartItem: builder.mutation({
      query: (id: any) => ({
        url: `carts/cart_items/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Cart', id: 'LIST' }],
    }),

    addCartItemService: builder.mutation({
      query: (cartItem: IaddCartItemService) => ({
        url: `/carts/cart_items`,
        method: 'POST',
        body: cartItem,
      }),
      invalidatesTags: [{ type: 'Cart', id: 'LIST' }],
    }),
    addCartItemProject: builder.mutation({
      query: (cartItem: IaddCartItemProject) => ({
        url: `/carts/cart_items`,
        method: 'POST',
        body: cartItem,
      }),
      invalidatesTags: [{ type: 'Cart', id: 'LIST' }],
    }),
    deleteCart: builder.mutation({
      query: () => ({
        url: `/carts`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Cart', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetCartItemsQuery,
  useDeleteCartItemMutation,
  useDeleteCartMutation,
  useAddCartItemProjectMutation,
  useAddCartItemServiceMutation,
} = CartApi;
